<template>
    <div
            v-if="errors.length"
            class="alert alert-danger mb-0"
    >
        <ul class="list-unstyled m-0">
            <li
                    v-for="(error, index) in errors"
                    v-bind:key="index"
                    class="small"
            >
                <i18n
                        v-if="error.friendly"
                        path="error"
                >
                    <span slot="email">{{ email }}</span>
                </i18n>

                <template v-else>
                    {{ error.message }}
                </template>
            </li>
        </ul>
    </div>
</template>

<script>
    import eventBus from './../eventBus';

    export default {
        data() {
            return {
                errors: []
            }
        },

        computed: {
            /**
             * Get email address.
             *
             * @return {string}
             */
            email() {
                return process.env.VUE_APP_EMAIL;
            }
        },

        mounted() {
            eventBus.$on('clearErrors', () => {
                this.errors = [];
            });

            eventBus.$on('error', (message, friendly = false) => {
                this.errors.push({
                    message: message,
                    friendly: friendly
                });
            });
        }
    }
</script>
